import { Pet, PetProfileFormValues } from '@app/core/models';
import { WeightFormValue } from '@app/shared/components/weight-form/weight-form';

export interface PatientProfileState {
  profile: PetProfileFormValues | null;
  weight?: WeightFormValue;
  isNewPet?: boolean;
  ongoingPet?: Pet;
}

export const initialPatientProfileState: PatientProfileState = {
  profile: null,
  weight: null,
  isNewPet: false,
  ongoingPet: null,
};
